import { getDefaultExportFromCjs as r } from "./index.es167.js";
import { __require as o } from "./index.es168.js";
var t = o();
const m = /* @__PURE__ */ r(t);
export {
  m as default
};
//# sourceMappingURL=index.es92.js.map
